import { Components } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

type CardProps = Components<Omit<Theme, 'components'>>['MuiCard'];

const getMuiCard = (): CardProps => ({
  styleOverrides: {
    root: () => ({
      '&:hover': {
        boxShadow: 'none',
      },
      borderless: {
        border: 'none',
      },
    }),
  },
  defaultProps: {
    elevation: 0,
    variant: 'elevation',
  },
});

export default getMuiCard;
